export default __webpack_public_path__ + "static/media/unforeseen-corners.4eea0daa.jpg";